import { useContext, useMemo } from "react";
import { useClaritySession } from "@/lib/auth/auth-store";
import { matchesPermission, type AnyPermission } from "@/lib/auth/permissions";
import { SessionPermissionsContext } from "@/lib/auth/session-permissions-context";

export function usePermissions() {
  const sessionPermissions = useContext(SessionPermissionsContext);
  const session = useClaritySession();

  return useMemo(() => {
    // Outside SessionPermissionsProvider (isolated tests), read the JWT directly.
    const { permissions, isLoading } = sessionPermissions ?? {
      permissions:
        session.status === "authenticated" ? session.permissions : [],
      isLoading: session.status === "loading",
    };
    const hasPermission = (required: AnyPermission) =>
      permissions.some((granted) => matchesPermission(granted, required));

    return {
      permissions,
      isLoading,
      hasPermission,
      hasAnyPermission: (required: AnyPermission[]) =>
        required.some(hasPermission),
      hasAllPermissions: (required: AnyPermission[]) =>
        required.every(hasPermission),
    };
  }, [session, sessionPermissions]);
}
